<template>
	<div class="countdown">
		<v-col class="pt-5">
			<v-row class="justify-center">
				<v-col cols="12" sm="6" md="4" class="text-center" v-if="loading">
					<!-- <div class="pa-5 text-center d-flex align-center justify-center">Sedang memuat data transaksi...</div> -->
					<hwiloader :messages="'Sedang memuat data transaksi...'"></hwiloader>
				</v-col>
				<v-col cols="12" sm="6" md="4" class="text-center" v-else>
					<div>
						<div class="text-h6 font-weight-bold">Transaksi Berhasil Diproses</div>
					</div>
					<div class="mt-3" v-if="detailTransaction.trx_status == 'Menunggu Pembayaran' && detailTransaction.trx_payment_method == 'Bank Transfer'">
						<v-alert
							text
							color="warning"
						>
							<small style="color: darkred; font-weight: 550;">Segera Konfirmasi Pembayaran Anda Agar Pesanan Dapat Segera Diproses.</small>
						</v-alert>
					</div>
					<div class="pt-3">
						<div class="font-size-13 grey--text text--darken-1">Kode Transaksi</div>
						<div class="pt-1 text-body-1 font-weight-bold">{{ detailTransaction.trx_code }}</div>
					</div>

					<v-row class="flex-column" v-if="detailTransaction.trx_status == 'Menunggu Pembayaran'">
						<v-col cols="12" class="pa-0" v-if="detailTransaction.trx_payment_method == 'Bank Transfer'">
							<timerpayment v-if="detailTransaction.trx_payment.trx_payment_bank_trf_expired_datetime" :date="detailTransaction.trx_payment.trx_payment_bank_trf_expired_datetime"></timerpayment>
						</v-col>
						<v-col cols="12" class="pa-0" v-else-if="detailTransaction.trx_payment_method == 'Virtual Account'">
							<timerpayment v-if="detailTransaction.trx_payment.trx_payment_va_expired_datetime" :date="detailTransaction.trx_payment.trx_payment_va_expired_datetime"></timerpayment>
						</v-col>
					</v-row>
					
					<v-row class="flex-column border" :class="(detailTransaction.trx_status !== 'Menunggu Pembayaran') ? 'mt-5 mb-1' : 'my-2'">
						<v-col cols="12" class="d-flex flex-column flex-sm-column flex-md-row align-start justify-md-space-between font-size-13 pb-0">
							<span>Metode Pembayaran</span>
							<span class="font-weight-bold text-right">{{ detailTransaction.trx_payment_method }}</span>
						</v-col>
						<v-col cols="12" class="d-flex flex-column flex-sm-column flex-md-row align-start justify-md-space-between font-size-13 pb-0">
							<span>Tujuan Pembayaran</span>

							<template v-if="detailTransaction.trx_payment_method == 'Bank Transfer'">
								<span class="font-weight-bold text-right">{{ detailTransaction.trx_payment.trx_payment_bank_trf_choose_company_bank_bank_name }} - {{ detailTransaction.trx_payment.trx_payment_bank_trf_choose_company_bank_account_no }} <small class="d-block">{{ detailTransaction.trx_payment.trx_payment_bank_trf_choose_company_bank_account_name }}</small></span>
							</template>
							<template v-else-if="detailTransaction.trx_payment_method == 'Virtual Account'">
								<div class="font-weight-bold text-right">
									VA {{detailTransaction.trx_payment.trx_payment_va_bank}}<br>
									<div class="d-flex align-center">
										{{ detailTransaction.trx_payment.trx_payment_va_number }}
										<v-btn
											small
											color="primary darken-2"
											elevation="0"
											outlined
											raised
											title="Copy"
											dark
											class="ml-2 px-2 white py-2"
											style="min-width: auto!important; border: 1px solid #ddd!important;"
											@click="copyme"
										>
											<span class="text-capitalize font-weight-medium green--text d-flex align-center"><v-icon small class="green--text darken-1 font-weight-normal">mdi-content-copy</v-icon></span>
										</v-btn>
									</div>
								</div>
								<input type="hidden" :value="detailTransaction.trx_payment.trx_payment_va_number.replaceAll(/\s/g, '')" id="inputCopy">
							</template>
						</v-col>
						<!-- <v-col cols="12" class="d-flex flex-column flex-sm-column flex-md-row align-start justify-md-space-between font-size-13 pb-0">
							<span>Batas Pembayaran</span>
							<span class="font-weight-bold text-right">{{ detailTransaction.trx_payment.trx_payment_bank_trf_expired_datetime }}</span>
						</v-col> -->
						<v-col cols="12" class="d-flex flex-column flex-sm-column flex-md-row align-start justify-md-space-between font-size-13" v-if="detailTransaction.trx_payment_method == 'Bank Transfer'">
							<span>Kode Unik</span>
							<span class="font-weight-bold text-right">{{ detailTransaction.trx_unique_code_nominal | toRupiah }}</span>
						</v-col>
						
						<v-col cols="12" class="d-flex flex-column flex-sm-column flex-md-row align-start justify-md-space-between font-size-13">
							<span>Total Pembayaran</span>
							<span class="font-weight-bold text-right font-size-15">{{ detailTransaction.trx_grand_total | toRupiah }}</span>
						</v-col>
					</v-row>
					<div class="pt-4">
						<img src="/assets/icons/payment-success.svg">
					</div>
					
					<div class="mt-5">
						<v-row class="justify-center">
							<v-col md="8" class="py-0">
								<div>
									<v-btn depressed height="45" block color="primary" class="rounded-lg mb-3" @click="uploadPayment" :loading="loadingConfirm" v-if="detailTransaction.trx_status == 'Menunggu Pembayaran' && detailTransaction.trx_payment_method == 'Bank Transfer'">
										<div class="font-weight-bold text-body-2">Konfirmasi Pembayaran</div>
									</v-btn>

									<router-link :to="'/transaction/detail/' + detailTransaction.trx_id" class="text-deco">
										<v-btn depressed height="45" block color="primary" class="rounded-lg mb-3" outlined>
											<div class="font-weight-bold text-body-2">Lihat Detail Transaksi</div>
										</v-btn>
									</router-link>

									<router-link :to="'/' + store_slug + '/'" class="text-deco">
										<v-btn text height="45" block color="primary" class="rounded-lg">
											<div class="font-weight-bold text-body-2">Belanja Kembali</div>
										</v-btn>
									</router-link>
								</div>
							</v-col>
						</v-row>
					</div>
				</v-col>
			</v-row>
		</v-col>

		<modalPayment ref="modalPayment" v-if="detailTransaction.trx_payment_method == 'Bank Transfer'" @action="confirmTransfer"></modalPayment>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import timerpayment from '@/components/Timer'
import modalPayment from '@/views/store/profile/ModalPayment'
export default {
	components: {
		timerpayment, modalPayment
	},
	data() {
		return {
			loading: false,
			loadingConfirm: false,
			store_slug: ''
		}
	},
	computed: {
		...mapState('transaction', ['detailTransaction']),
	},
	methods: {
		...mapActions('transaction', ['getTransactionDetail', 'payTransaction']),
		downloadPDF(pdf) {
			window.open(pdf)
		},

		uploadPayment() {
			this.$refs.modalPayment.modalShow(this.detailTransaction.trx_grand_total)
		},

		confirmTransfer(data) {
			this.loadingConfirm = true
			data.append('trx_id', this.detailTransaction.trx_id)
			this.payTransaction(data).then(() => {
				this.$refs.modalPayment.modalHide()
				// this.getDetail()

				setTimeout(() => {
					this.loadingConfirm = false
				}, 600);
			})
			.catch(() => {
				this.loadingConfirm = false
			})
			.finally(() => {
				setTimeout(() => {
					this.loadingConfirm = false
					this.$router.push(`/transaction/detail/${this.detailTransaction.trx_id}`).catch(() => {});
				}, 600);
			})
		},

		copyme() {
      var copyText = document.getElementById("inputCopy")
      copyText.setAttribute('type', 'text')
      copyText.select()
      try {
        document.execCommand('copy');
        setTimeout(() => {
          this.$store.commit('makeAlert', { code: 'success', type: 'success', message: 'No. Virtual Account berhasil disalin', show: true });
        }, 300);
      } catch (err) {
        alert('Oops, tidak dapat menyalin');
      }
      copyText.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
	},
	created() {
		this.$store.dispatch('setPageTitle', 'Pembayaran');
		this.store_slug = this.$route.params.slug
		this.loading = true
		this.getTransactionDetail({trx_id: this.$route.params.id})
			.then(() => {
				// console.log(res)
			})
			.catch((error) => {
				// err = error
				console.log(error)
				setTimeout(() => {
					this.$router.push(`/transaction/list`).catch(() => {});
				}, 800);
			})

		setTimeout(() => {
			this.loading = false
		}, 2000);
	}
};
</script>